import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { dailyChallengesSelector } from 'store/dailyChallenges/selectors';

import { usePagination } from 'hooks/usePagination';

import DailyChallengesTable from './DailyChallengesTable';

const DailyChallengesTableContainer = ({
  dataAction,
  params,
  ...restProps
}: { dataAction: any; params: Record<string, any> } & Record<string, any>) => {
  const { i18n } = useTranslation();
  const { currentPage, totalPages, perPage } = useSelector(
    dailyChallengesSelector,
  );

  const [onPerPageChange, onPrevPageClick, onNextPageClick] = usePagination({
    dataAction,
    currentPage,
    totalPages,
    perPage,
    sortBy: params.sortBy,
    sortDirection: params.sortDirection,
  });

  return (
    <DailyChallengesTable
      {...restProps}
      locale={i18n.language}
      currentPage={currentPage}
      totalPages={totalPages}
      perPage={perPage}
      params={params}
      onPerPageChange={onPerPageChange}
      onPrevPageClick={onPrevPageClick}
      onNextPageClick={onNextPageClick}
    />
  );
};

export default React.memo(DailyChallengesTableContainer) as any;
